import { useContext, useEffect, useState, type FC } from "react";
import MainLayout from "../components/MainLayout";
import { LoadingContext } from "../contexts/LoadingContext";
import {
  ProductRecommendation,
  SumProductRecommendation,
} from "../models/inventory/product";
import {
  addProductRecommendation,
  getProductRecommendations,
} from "../services/inventory/ProductApi";
import PlusIcon from "@rsuite/icons/Plus";
import ProductRecommendationForm from "../components/features/inventory/ProductRecommendationForm";
import { errorToast } from "../utils/helper-ui";
import { Checkbox, IconButton, Table } from "rsuite";
import { money } from "../utils/helper";

const { Column, HeaderCell, Cell } = Table;

interface ProductRecommendationProps {}

const ProductRecommendationPage: FC<ProductRecommendationProps> = ({}) => {
  const [mounted, setMounted] = useState(false);
  const [recommendations, setRecommendations] = useState<
    SumProductRecommendation[]
  >([]);
  const [modalFormOpen, setModalFormOpen] = useState(false);
  const { isLoading, setIsLoading } = useContext(LoadingContext);
  const [checkedKeys, setCheckedKeys] = useState<string[]>([]);
  const [selected, setSelected] = useState<ProductRecommendation>();
  let checked = false;
  let indeterminate = false;

  if (checkedKeys.length === recommendations.length) {
    checked = true;
  } else if (checkedKeys.length === 0) {
    checked = false;
  } else if (
    checkedKeys.length > 0 &&
    checkedKeys.length < recommendations.length
  ) {
    indeterminate = true;
  }

  const handleCheckAll = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked ? recommendations.map((item) => item.product_id) : [];
    setCheckedKeys(keys);
  };
  const handleCheck = (
    value: any,
    checked: boolean,
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    const keys = checked
      ? [...checkedKeys, value as string]
      : checkedKeys.filter((item) => item !== (value as string));
    setCheckedKeys(keys);
  };

  useEffect(() => {
    setMounted(true);

    return () => {
      setMounted(false);
    };
  }, []);

  const onSubmit = async (val: any) => {
    try {
      setIsLoading(true);

      await addProductRecommendation(val);
      getProductRecommendations()
        .then((v) => v.json())
        .then((v) => setRecommendations(v.data));
      setModalFormOpen(false);
    } catch (error) {
      errorToast(`${error}`);
    } finally {
      setIsLoading(false);
    }
  };
  useEffect(() => {
    if (!mounted) return;
    getProductRecommendations()
      .then((v) => v.json())
      .then((v) => setRecommendations(v.data));
  }, [mounted]);

  const renderHeader = () => (
    <div className="flex flex-row justify-between items-center px-2">
      <h1 className="text-2xl font-semibold">Product Recommendation</h1>
      <div>
        <IconButton
          size="sm"
          appearance="primary"
          color="green"
          icon={<PlusIcon />}
          onClick={() => setModalFormOpen(true)}
        >
          Add Recommendation
        </IconButton>
      </div>
    </div>
  );

  return (
    <MainLayout header={renderHeader()}>
      <div className="w-full overflow-x-auto">
        <table className="min-w-full divide-y divide-gray-200 text-sm">
          <thead className="bg-gray-50">
            <tr>
              <th scope="col" className="px-4 py-2 text-left border bg-gray-50" style={{ width: 100 }}>
                <div className="flex items-center">
                  <Checkbox
                    inline
                    checked={checked}
                    indeterminate={indeterminate}
                    onChange={handleCheckAll}
                  />
                </div>
              </th>
              <th className="px-4 py-2 text-left border">Name</th>
              <th className="px-4 py-2 text-left border">Score</th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {recommendations.map((product, i) => (
              <tr key={product.product_id}>
                <td className="px-4 py-2 border">
                  <Checkbox
                    value={product.product_id}
                    inline
                    onChange={handleCheck}
                    checked={checkedKeys.some(
                      (item) => item === product.product_id
                    )}
                  />
                  {i + 1}
                </td>
                <td
                  className="px-4 py-2 border"
                  onClick={() => {}}
                >
                  {product.product_name}
                </td>
                <td className="px-4 py-2 border">
                  {money(product.total_score)}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {/* <Table
        minHeight={700}
        data={recommendations}
        onRowClick={(data, i) => {}}
      >
        <Column width={50} align="center" fixed>
          <HeaderCell style={{ padding: 0 }}>
            <div style={{ lineHeight: "40px" }}>
              <Checkbox
                inline
                checked={checked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </div>
          </HeaderCell>
          <Cell style={{ padding: 0 }}>
            {(product) => (
              <div style={{ lineHeight: "46px" }}>
                <Checkbox
                  value={product.product_id}
                  inline
                  onChange={handleCheck}
                  checked={checkedKeys.some(
                    (item) => item === product.product_id
                  )}
                />
              </div>
            )}
          </Cell>
        </Column>
        <Column width={70} align="center" fixed>
          <HeaderCell>No</HeaderCell>
          <Cell>
            {(product) => (
              <div>
                {recommendations.indexOf(product as SumProductRecommendation) +
                  1}
              </div>
            )}
          </Cell>
        </Column>

        <Column width={200} resizable fixed>
          <HeaderCell>Name</HeaderCell>
          <Cell>
            {(product) => (
              <div
                className="hover:underline cursor-pointer font-semibold "
                onClick={() => {}}
              >
                {product.product_name}
              </div>
            )}
          </Cell>
        </Column>
        <Column width={100} resizable>
          <HeaderCell>Score</HeaderCell>
          <Cell>{(product) => <div>{money(product.total_score)}</div>}</Cell>
        </Column>
      </Table> */}
      <ProductRecommendationForm
        open={modalFormOpen}
        onClose={() => setModalFormOpen(false)}
        onSubmit={onSubmit}
        recommendation={selected}
      />
    </MainLayout>
  );
};
export default ProductRecommendationPage;
